var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _ellipse, _ellipse2, _path12, _g, _rect3, _rect4, _g2, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrillavaciaPlancuidado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 200,
    viewBox: "0 0 156 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ilustracion 01"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 8",
    d: "M142.146 143.997C142.146 177.134 115.283 199.997 82.1464 199.997C49.0096 199.997 18.147 175.997 18.147 123.998C18.147 71.9987 94.1462 0 110.146 0C116.025 0 94.4066 32.1292 98.1462 63.9989C101.695 94.2459 142.146 109.909 142.146 143.997Z",
    fill: "#B9D1EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 20 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1624 110.929C31.4267 117.184 25.4767 126.432 25.4767 133.68C25.4767 138.381 26.6552 140.482 27.5366 141.25C28.1069 141.746 31.6871 144.379 44.1024 141.533L49.7277 166.069C33.7892 169.723 20.3571 168.379 11.0035 160.232C1.96109 152.356 0.304199 141.146 0.304199 133.68C0.304199 112.079 16.9597 95.9789 36.3262 87.7578L46.1624 110.929Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 21 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.511 125.548C130.114 134.47 131.008 142.551 130.319 145.778C129.337 150.372 128.013 150.992 126.967 151.382C124.484 152.31 118.214 152.901 104.689 148.919L97.5792 173.067C112.408 177.433 125.362 178.854 135.777 174.963C147.628 170.535 152.874 160.688 154.936 151.036C157.29 140.017 153.965 125.799 147.883 114.008C141.635 101.897 130.964 89.3721 115.487 84.0127L107.25 107.799C114.594 110.342 121.074 116.945 125.511 125.548Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 111",
    d: "M43.5957 109.387C43.5957 94.501 55.6632 82.4336 70.5491 82.4336H92.1602C107.046 82.4336 119.114 94.5011 119.114 109.387V183.677H43.5957V109.387Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 109",
    x: 63.2358,
    y: 26.5566,
    width: 36.2375,
    height: 46.1956,
    rx: 18.1188,
    fill: "#BDBDBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 110",
    x: 70.9817,
    y: 47.8545,
    width: 20.7467,
    height: 45.3657,
    rx: 10.3733,
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4815 81.2802L81.6317 116.181L101.886 81.0996C120.341 83.3731 133.713 91.9788 142.17 105.061L121.03 118.727C120.449 117.829 119.814 116.951 119.114 116.103V183.677H43.5964V112.236C38.9308 114.5 35.0343 117.209 32.0811 120.138L14.3542 102.266C25.718 90.9951 42.6667 83.6012 61.4815 81.2802Z",
    fill: "#0063BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.222 112.882L121.171 118.734C120.589 117.835 119.954 116.957 119.254 116.109V188.791C109.066 195.951 96.2313 200 82.2858 200C68.3182 200 54.7546 195.736 43.7362 186.908V112.244C39.0709 114.507 35.1747 117.217 32.2217 120.146L20.3579 108.185C21.5285 103.454 23.1619 98.6422 25.1716 93.8079C35.4133 87.2879 48.0305 82.9642 61.6214 81.2875L81.7712 116.188L102.026 81.1064C102.936 81.2186 103.835 81.3462 104.721 81.489C108.742 88.0511 114.12 94.1107 119.547 100.226C123.218 104.362 126.911 108.523 130.222 112.882Z",
    fill: "#0063BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M108.463 82.4336L81.6308 126.14L54.1068 82.4336",
    stroke: "#003C73",
    strokeOpacity: 0.1,
    strokeWidth: 1.10649
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 113",
    d: "M63.2357 26.001H99.4732L101.41 41.7683H61.2993L63.2357 26.001Z",
    fill: "#0063BE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 112",
    d: "M64.8977 24.0654H97.5355L100.027 42.0458H62.4062L64.8977 24.0654Z",
    fill: "#0063BE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M55.7669 82.709C55.7669 81.9451 55.1477 81.3259 54.3838 81.3259C53.6199 81.3259 53.0007 81.9451 53.0007 82.709L55.7669 82.709ZM53.0007 82.709L53.0007 108.988L55.7669 108.988L55.7669 82.709L53.0007 82.709Z",
    fill: "#003C73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M55.0755 107.606C49.8047 107.606 45.532 111.879 45.532 117.15V133.747C45.532 138.034 48.3592 141.662 52.2511 142.866C53.0705 143.119 53.8307 142.45 53.8307 141.592C53.8307 140.907 53.3348 140.335 52.6937 140.094C50.1257 139.13 48.2982 136.652 48.2982 133.747V117.15C48.2982 113.407 51.3325 110.373 55.0755 110.373C58.8184 110.373 61.8527 113.407 61.8527 117.15V133.747C61.8527 136.652 60.0252 139.13 57.4573 140.094C56.8161 140.335 56.3203 140.907 56.3203 141.592C56.3203 142.45 57.0804 143.119 57.8998 142.866C61.7917 141.662 64.6189 138.034 64.6189 133.747V117.15C64.6189 111.879 60.3462 107.606 55.0755 107.606Z",
    fill: "#003C73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6187 124.479H61.8525V133.745C61.8525 136.65 60.025 139.128 57.457 140.092C56.8159 140.333 56.32 140.905 56.32 141.59C56.32 142.448 57.0801 143.117 57.8996 142.864C61.7914 141.66 64.6187 138.033 64.6187 133.745V124.479ZM48.298 124.479H45.5317V133.745C45.5317 138.033 48.359 141.66 52.2509 142.864C53.0703 143.117 53.8304 142.448 53.8304 141.59C53.8304 140.905 53.3345 140.333 52.6934 140.092C50.1254 139.128 48.298 136.65 48.298 133.745V124.479Z",
    fill: "#B9D1EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Intersect_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6645 142.114C60.0003 141.929 60.1938 141.568 60.1938 141.185C60.1938 140.149 58.7489 139.535 57.7998 139.952C57.6875 140.001 57.5736 140.047 57.4582 140.091C56.8171 140.331 56.3212 140.904 56.3212 141.588C56.3212 142.446 57.0814 143.116 57.9008 142.862C58.5178 142.671 59.108 142.42 59.6645 142.114ZM52.3528 139.951C51.4037 139.534 49.9587 140.148 49.9587 141.185C49.9587 141.568 50.1521 141.929 50.4879 142.114C51.0445 142.419 51.6349 142.671 52.2521 142.862C53.0715 143.116 53.8316 142.446 53.8316 141.588C53.8316 140.904 53.3358 140.331 52.6946 140.091C52.5792 140.047 52.4652 140.001 52.3528 139.951Z",
    fill: "#BDBDBD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 24",
    cx: 108.603,
    cy: 115.35,
    rx: 6.91556,
    ry: 6.91551,
    fill: "#B9D1EB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 25",
    cx: 108.601,
    cy: 115.351,
    rx: 4.42596,
    ry: 4.42593,
    fill: "#003C73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M108.602 82.709L108.602 115.35",
    stroke: "#003C73",
    strokeWidth: 2.76621,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 115",
    width: 27.4737,
    height: 25.0248,
    rx: 12.5124,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 27.4719 144.985)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 116",
    width: 39.3455,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 32.4092 143.978)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 117",
    width: 39.3455,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 23.3899 152.207)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118",
    width: 39.3455,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 25.637 158.132)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119",
    width: 25.1563,
    height: 6.25619,
    rx: 3.1281,
    transform: "matrix(0.979734 -0.200305 0.200308 0.979733 38.4724 161.896)",
    fill: "#BDBDBD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 40"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120",
    x: 72.917,
    y: 123.926,
    width: 40.9401,
    height: 57.9826,
    rx: 5.53243,
    fill: "#719FDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 121",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1108,
    y: 129.114,
    width: 13.1527,
    height: 4.6312,
    rx: 2.3156,
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 116_2",
    width: 24.0163,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.962889 -0.269906 0.269909 -0.962884 111.81 176.818)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 117_2",
    width: 34.9348,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.922013 -0.387162 0.387167 -0.922009 118.405 174.754)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118_2",
    width: 24.1948,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.902417 -0.430865 0.43087 -0.902413 112.732 165.998)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119_2",
    width: 25.1563,
    height: 6.2562,
    rx: 3.1281,
    transform: "matrix(-0.866027 -0.499997 0.500003 -0.866024 119.323 163.222)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120_2",
    x: 113.304,
    y: 169.546,
    width: 25.1562,
    height: 6.25624,
    rx: 3.12811,
    transform: "rotate(-89.0674 113.304 169.546)",
    fill: "#BDBDBD"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 21 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.965 150.953C127.417 151.348 125.259 152.563 118.999 151.998C117.575 151.87 115.979 151.652 114.195 151.324L109.648 176.083C112.094 176.532 114.458 176.863 116.739 177.069C126.35 177.936 135.398 176.62 142.674 171.381C150.037 166.08 153.391 158.347 154.935 151.118L130.318 145.859C129.516 149.616 128.427 150.621 127.965 150.953Z",
    fill: "#BDBDBD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrillavaciaPlancuidado);
export default __webpack_public_path__ + "static/media/grillavacia-plancuidado.3c5dec7206a99cccf01029fbff012542.svg";
export { ForwardRef as ReactComponent };